import React, { createContext, useContext, useMemo, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../services/api';
const AuthContext = createContext(null);
const TOKEN_KEY = 'adminToken';
const ADMIN_KEY = 'adminProfile';
function readStoredAdmin() {
  try {
    return JSON.parse(sessionStorage.getItem(ADMIN_KEY) || 'null');
  } catch {
    return null;
  }
}
export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => sessionStorage.getItem(TOKEN_KEY) || '');
  const [admin, setAdmin] = useState(readStoredAdmin);
  const login = async (email, password) => {
    const loginPath = process.env.REACT_APP_ADMIN_LOGIN_ENDPOINT || '/api/admin/login';
    const response = await axios.post(
      `${API_BASE_URL}${loginPath}`,
      { email, password },
      { timeout: 20000 },
    );
    const payload = response.data || {};
    const newToken =
      payload.token || payload.accessToken || payload.data?.token || payload.data?.accessToken;
    if (!newToken) {
      throw new Error(
        payload.message || 'Login API did not return a token. Check the login endpoint response.',
      );
    }
    // The backend login API returns the admin profile directly in payload.data.
    const user =
      payload.admin ||
      payload.user ||
      payload.data?.admin ||
      payload.data?.user ||
      (payload.data?.id || payload.data?._id ? payload.data : { email });
    sessionStorage.setItem(TOKEN_KEY, newToken);
    sessionStorage.setItem(ADMIN_KEY, JSON.stringify(user));
    setToken(newToken);
    setAdmin(user);
    return user;
  };
  const logout = () => {
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(ADMIN_KEY);
    setToken('');
    setAdmin(null);
  };
  const value = useMemo(
    () => ({ token, admin, isAuthenticated: Boolean(token), login, logout }),
    [token, admin],
  );
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
export const useAuth = () => useContext(AuthContext);
